export const plans = [
  {
    name: 'InterviewAdvantage Student',
    short_name: 'Student',
    description: 'Interview Advantage Student',
    popular: false,
    price: '79',
    features: [
      'One (1) Interview Advantage Report',
      '**Requires .edu email**',
      '7-day 100% money back guarantee'
    ],
    stripeProductId: 'price_1Qid5DCBvNoqu9ZwFfnxrBAQ'
  },  
  {
    name: 'InterviewAdvantage Basic',
    short_name: 'Basic',
    description: 'Interview Advantage Basic',
    popular: false,
    price: '129',
    features: [
      'One (1) Interview Advantage Report',
      '7-day 100% money back guarantee'
    ],
    stripeProductId: 'price_1Qid72CBvNoqu9ZwFtblgaqK'
  },
  {
    name: 'InterviewAdvantage Plus',
    short_name: 'Plus',
    description: 'Interview Advantage Plus',
    popular: true,
    price: '299',
    features: [
      '3 Interview Advantage Reports',
      'Good for 1-year',
      '7-day 100% money back guarantee'
    ],
    stripeProductId: 'price_1Qid8ICBvNoqu9ZwPZubjWXu'
  },
  {
    name: 'InterviewAdvantage Platinum',
    short_name: 'Platinum',
    description: 'Interview Advantage Platinum',
    popular: false,
    price: '699',
    features: [
      '10 Interview Advantage Reports',
      'Good for 1-year',
      '7-day 100% money back guarantee'
    ],
    stripeProductId: 'price_1Qid9HCBvNoqu9ZwsLr8Pypf'
  }
] as const;